module.exports = __webpack_public_path__ + "static/media/logo-slaek_2x.7f8e03f6.png";